module.exports = __webpack_public_path__ + "img/address.e1560c0c.png";